import Amount from "@/models/Shared/Amount";
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import CurrencyUtils from '@/lib/currencyUtils';

export default (amount: Amount) => {

    // Step 1 - Check all amount fields exist to prevent null pointer errors
    if (!amount || !amount.amount || !amount.currency) {
        return "";
    }

    // Step 2 - Work out the number of decimal places to use, do this by checking
    // the list of currencies which is hardcoded in utils and contains the number
    // of decimal places set for each currency (ideally this would come from the API instead of hardcoded?)
    const allCurrencies = CurrencyUtils.getListOfCurrencies();
    const thisCurrency = allCurrencies.find((currency) => { return currency.code === amount.currency; });
    const numberOfDecimals = thisCurrency.decimals;

    // Step 3 - Work out what currency code to use, if the CryptocurrencyOverride is
    // enabled then override some of the currencies with crypto currency, replace BTC
    // with XPT and replace ETH with XPD, otherwise use the currency code provided
    let currencyCode = amount.currency;
    if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.CryptocurrencyOverride)) {
        if (amount.currency === 'XPT') {
            currencyCode = 'BTC';
        }
        else if (amount.currency === 'XPD') {
            currencyCode = 'ETH';
        }
    }

    // Step 4 - Put it all together
    let val = (Number(amount.amount) / 100);
    var formatter = new Intl.NumberFormat(
        'en-GB', {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'code',
            minimumFractionDigits: numberOfDecimals
        }
    );
    return formatter.format(val);
}